import { create } from 'zustand';
import { isThemeId } from '@secretnenshi/content';
import { DEFAULT_THEME_ID, type GameView, type PrivatePlayerState, type ReclaimRequest, type SessionInfo, type ThemeId } from '@secretnenshi/shared';
import { getChosenTheme } from './storage';

export type InfoPage = 'how-to-play' | 'characters' | 'sources' | 'about' | 'disclaimer';

export type Screen =
  | { name: 'landing' }
  | { name: 'create' }
  | { name: 'join'; code?: string; playerName?: string }
  | { name: 'reclaim'; code: string; playerName: string; requestId: string }
  | { name: 'game' }
  | { name: 'info'; page: InfoPage };

export interface Notice {
  kind: 'error' | 'info';
  text: string;
}

export interface AppState {
  /** Game variant chosen on the main menu (a game's own theme wins inside it). */
  themeId: ThemeId;
  connected: boolean;
  screen: Screen;
  session: SessionInfo | null;
  /** Public game view: identical for every player. */
  view: GameView | null;
  /** When the view arrived, for counting down its timer on this phone's clock. */
  viewReceivedAt: number;
  /** This player's own secrets. Cleared whenever the seat is lost. */
  priv: PrivatePlayerState | null;
  /** Host only: pending seat reclaim requests. */
  reclaimRequests: ReclaimRequest[];
  notice: Notice | null;
  busy: boolean;
}

const saved = getChosenTheme();

export const initialState: AppState = {
  themeId: saved && isThemeId(saved) ? saved : DEFAULT_THEME_ID,
  connected: false,
  screen: { name: 'landing' },
  session: null,
  view: null,
  viewReceivedAt: 0,
  priv: null,
  reclaimRequests: [],
  notice: null,
  busy: false,
};

export const useStore = create<AppState>(() => ({ ...initialState }));

export const set = useStore.setState;
export const get = useStore.getState;
